import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router-dom';
import { CMORecordsStepClient } from '@/features/cmo-records/ui/cmo-records-step-client';
import { useUser } from '@/shared/providers/user-context';
import { USER_ROLE, type UserRole } from '@/shared/types/user';
import { Spinner } from '@/shared/ui';

const authorizedRoles: readonly UserRole[] = [USER_ROLE.ADMIN, USER_ROLE.MANAGER];

export function CMORecordsStepPage() {
  const { step: stepParam } = useParams<{ step: string }>();
  const step = Number(stepParam);
  const { user, isLoading } = useUser();

  if (isLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner size="sm" />
      </div>
    );
  }

  // 권한 체크
  if (user && !authorizedRoles.includes(user.role)) {
    return (
      <Navigate
        replace
        to="/records"
      />
    );
  }

  return (
    <>
      <Helmet>
        <title>수탁사 기록서 만들기 | 동구바이오제약</title>
      </Helmet>
      <Suspense
        fallback={
          <div className="w-full h-full flex items-center justify-center">
            <Spinner size="sm" />
          </div>
        }
      >
        <CMORecordsStepClient step={step} />
      </Suspense>
    </>
  );
}
